module.exports = __webpack_public_path__ + "img/logo_LA.e9ba0b6d.png";